import { BusinessWithUsers } from '@store/entities/businesses/types';

export const extractBusinessCountryCode = (business: BusinessWithUsers) => {
  const { locations = [] } = business;

  return locations[0]?.countryCode.toLowerCase();
};
